export const getCurrentTime = ()=>{
  return { seconds: Date.now() / 1000 | 0, nanoseconds:0 };
};

export const fnBrowserDetect=():'chrome'|'firefox'|'safari'|'opera'|'edge'|'No browser detection'=>{
                 
  const userAgent = navigator.userAgent;
  
  if(userAgent.match(/chrome|chromium|crios/i)){
    return 'chrome';
  }else if(userAgent.match(/firefox|fxios/i)){
    return 'firefox';
  } else if(userAgent.match(/safari/i)){
    return 'safari';
  }else if(userAgent.match(/opr\//i)){
    return 'opera';
  } else if(userAgent.match(/edg/i)){
    return 'edge';
  }else{
    return 'No browser detection';
  }
};


export function sliceIntoChunks(arr:string[], chunkSize:number) {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
}